import Sparkle from '../../src/legacy/Sparkle.tsx';
export default Sparkle;
